
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"25","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.667 5v18.333H15.222a.222.222 0 01-.08-.429v-.002c1.976-.757 3.834-2.577 5.367-5.94l1.707-3.746C25.296 6.456 27.019 5 31.666 5zM18.19 2.096v.002c-1.977.758-3.834 2.578-5.367 5.94l-1.706 3.746C8.038 18.544 6.314 20 1.667 20V1.667h16.445a.222.222 0 01.079.429zM0 25h33.333V0H0v25z","fill":"#FFF","fill-rule":"evenodd"}})])
          )
        }
      }
    